import { useMotionValue } from 'motion/react';
import { RefObject, useEffect } from 'react';

export const useBoundingClientRectMotion = (ref: RefObject<Element | null>) => {
  const boundingClientRect = useMotionValue<DOMRect>({
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    bottom: 0,
    left: 0,
    right: 0,
    top: 0,
    toJSON: () => {},
  });

  useEffect(() => {
    if (!ref.current) return;

    const update = () => {
      if (!ref.current) return;

      boundingClientRect.set(ref.current?.getBoundingClientRect());
    };

    window.addEventListener('resize', update);
    window.addEventListener('scroll', update);

    return () => {
      window.removeEventListener('resize', update);
      window.removeEventListener('scroll', update);
    };
  }, [ref, boundingClientRect]);

  return boundingClientRect;
};
